import { createSlice } from '@reduxjs/toolkit'
import { createLumberCalculation } from 'redux/service/lumberService/lumberService';

const initialState = {
  createLumberCalculationRes: { data: [], isFetching: false, error: null },
}

export const lumberCalculatorSlice = createSlice({
  name: 'lumberCalculatorSlice',
  initialState,
  extraReducers: (builder) => {
    // builder
    const asyncActionCases = [
      { api: createLumberCalculation, name: "createLumberCalculationRes" },
    ];
    asyncActionCases.map((asyncAction) => {
      builder
        .addCase(asyncAction.api.fulfilled, (state, { payload }) => {
          state[asyncAction.name].isFetching = false;
          state[asyncAction.name].data = payload;
        })
        .addCase(asyncAction.api.pending, (state) => {
          state[asyncAction.name].isFetching = true;
          state[asyncAction.name].error = null;
        })
        .addCase(asyncAction.api.rejected, (state, { payload }) => {
          state[asyncAction.name].isFetching = false;
          state[asyncAction.name].error = payload;
        });
    });
  },
})


export const { lumberCalculatorDispatch } = lumberCalculatorSlice.actions
